// REMEMBER: ONLY PUT KEYS/VARIABLES THAT CAN BE EXPOSED ON THE CLIENT-SIDE

// note: all custom env vars must be prefixed with 'REACT_APP_'
// for it to be exposed in process.env: https://create-react-app.dev/docs/adding-custom-environment-variables/
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!;
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID!;

export const COSMOS_ASSET_BUCKET = process.env.REACT_APP_COSMOS_ASSET_BUCKET!;
export const GOOGLE_OAUTH_2_CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH_2_CLIENT_ID!;
